import React from "react";
import goal3 from "../../../images/achievementimage/goal3.jpeg"
const AchievementSection2 = () => {
  return (
    <div className="mt-80 lg:flex">
      <div className="bg-blue-500 pt-40 pb-28 lg:w-3/5 lg:h-[80vh]">
        <img
          className="mx-6 w-20 lg:mx-36"
          src="https://cdn-icons-png.flaticon.com/512/1018/1018524.png"
          alt=""
        />
        <h1 className="mx-5 mt-3 text-5xl font-bold lg:text-6xl lg:mx-36">Role of school in achieving education-</h1>
        <p className="mx-6 mt-9 text-xl lg:mx-36 lg:text-2xl">
          School is the foremost fountain of knowledge children are exposed to.
          It gives a chance for them to acquire knowledge on various fields of
          education such as people, literature, history, mathematics, politics,
          and other numerous subjects. This contributes to cultivation in the
          thought process.
        </p>
      </div>
      <div>
        <img
          className="hidden h-full lg:h-[80vh] lg:block"
          src={goal3}
          alt=""
        />
      </div>
    </div>
  );
};

export default AchievementSection2;
